import invoice from './invoice';
import group from './invoiceGroup';
import querySingleDetail from './querySingleDetail';
import queryManageSingleDetail from './queryManageSingleDetail';
import groupInvoice from './groupInvoice';
import realcheckQuery from './realcheckQuery';
import groupInfo from './groupInfo';
import groupSaveDetail from './groupSaveDetail';
import CreatGroup from './createGroup';
import GetGroupList from './getGroupList';
import MoveGroup from './moveGroup';
import DeleteGroup from './deleteGroup';
import ImgQuery from './imgQuery';
import invoiceLogList from './invoiceLogList';
import InvoiceFinance from './invoiceFinance';
import InvoiceCollect from './invoiceCollect';
import InvoiceGroupFinance from './invoiceGroupFinance';
import addRest from './AddRest';
import saveRest from './SaveRest';
import groupExist from './groupExist';
import autoSubmitBtn from './autoSubmitBtn';
import loggingSubmit from './loggingSubmit';
import invoiceSubmit from './invoiceSumbit';
import submitAllGroup from './submitAllGroup';
import loggingAllGroupSubmit from './loggingAllGroupSumbit';
import realCheck from './realCheckAgain';
export default {
    group,
    invoice,
    groupInvoice,
    groupInfo,
    groupSaveDetail,
    /** 发票详情 */
    querySingleDetail,
    queryManageSingleDetail,
    CreatGroup,
    GetGroupList,
    MoveGroup,
    realcheckQuery,
    DeleteGroup,
    ImgQuery,
    invoiceLogList,
    InvoiceFinance,
    InvoiceCollect,
    InvoiceGroupFinance,
    addRest,
    saveRest,
    groupExist,
    autoSubmitBtn,
    loggingSubmit,
    invoiceSubmit,
    submitAllGroup,
    loggingAllGroupSubmit,
    realCheck
};


// WEBPACK FOOTER //
// ./src/api/invoiceInput/index.ts